// @flow

import React from 'react';
import { Heading, Paragraph, Button } from 'operation-diameter';

import styles from './LoginNotice.module.css';

type Props = {
  email: string,
  onCloseClick: (event: SyntheticEvent<HTMLButtonElement>) => void
};

const MagicLinkSuccess = ({ email, onCloseClick }: Props) => (
  <div
    className={styles.magicLinkSuccessWrapper}
    data-testid='magic-link-success'>
    <Heading headingSize='h5'>Secure link sent!</Heading>
    <div className={styles.magicLinkSuccessContent}>
      <Paragraph
        paragraphWeight='500'
        additionalClassnames={styles.magicLinkHeading}>
        We’ve sent an email with your secure link to:
        <Paragraph paragraphWeight='600'>{email}</Paragraph>
      </Paragraph>

      <Paragraph>
        Your link will expire in 10 minutes. If you can’t see the email please
        check your spam or junk folder, or request another.
      </Paragraph>
      <Button
        size='large'
        type='submit'
        onClick={onCloseClick}
        additionalClassnames={styles.linkSentButton}>
        Close
      </Button>
    </div>
  </div>
);

export default MagicLinkSuccess;
